import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { useBrand } from "@/lib/brand";

/**
 * FloatingContact — fixed bottom-right call + WhatsApp buttons.
 *
 * Rendered once from SiteFooter (present on every tenant page already),
 * so every page gets it without each page having to wire it in. Reads
 * straight off brand.business — nothing tenant-specific to configure.
 */
export default function FloatingContact() {
  const brand = useBrand();
  const biz = brand.business || {};
  if (!biz.phone) return null;

  const telHref = `tel:${(biz.phone_intl || biz.phone).replace(/\s/g, "")}`;
  const waNumber = (biz.phone_intl || "").replace(/[^\d]/g, "");

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-contact">
      {waNumber && (
        <a
          href={`https://wa.me/${waNumber}`}
          target="_blank"
          rel="noreferrer"
          aria-label="Message us on WhatsApp"
          data-testid="floating-whatsapp"
          className="w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-105"
          style={{ background: "#25D366", color: "#fff" }}
        >
          <MessageCircle className="w-5 h-5" />
        </a>
      )}
      <a
        href={telHref}
        aria-label={`Call ${biz.phone}`}
        data-testid="floating-call"
        className="w-12 h-12 rounded-full flex items-center justify-center shadow-lg bg-primary text-primary-foreground transition-transform hover:scale-105"
      >
        <Phone className="w-5 h-5" />
      </a>
    </div>
  );
}
